'use client';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import React, { useState } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { useSearchParams } from 'next/dist/client/components/navigation';
import { SnackbarProvider } from 'notistack';
import { AppRouterCacheProvider } from '@mui/material-nextjs/v14-appRouter';
import { GlobalStyles } from '@mui/system';
import { createI18n } from 'common/i18n';
import theme from 'link/src/theme';

const queryClient = new QueryClient();

export const Layout = ({ children }: { children: React.ReactNode }) => {
    const searchParams = useSearchParams();
    useState(() => createI18n(searchParams.get('locale') ?? undefined));

    return (
        <QueryClientProvider client={queryClient}>
            <AppRouterCacheProvider>
                <ThemeProvider theme={theme}>
                    <SnackbarProvider>
                        <GlobalStyles
                            styles={{
                                body: { backgroundColor: theme.palette.background.default },
                            }}
                        />
                        {children}
                    </SnackbarProvider>
                </ThemeProvider>
            </AppRouterCacheProvider>
        </QueryClientProvider>
    );
};
